import { ChatInput } from "@bonusx-global/bx-design-system";
import type { PropsWithChildren } from "react";
import { memo } from "react";
import { EmptyComponent } from "../../../common/EmptyComponent";
import { ChatbotHeader } from "../chatbot.header";
import { ChatbotInputContainer } from "../chatbot.input-container";
import { ChatbotWrapper } from "../chatbot.wrapper";
import ChatbotScrollToBottomButton from "../scroll-to-bottom-button/chatbot-scroll-to-bottom-button";
import type { IChatbotLayoutWrapper } from "./chatbot-layout-wrapper.interface";

export const CHATBOT_LAYOUT_WRAPPER_ID = "chatbot-layout-wrapper";

function ChatbotLayoutWrapper({
  chatbotName,
  handleClose,
  messages,
  disabled,
  handleNewSession,
  showScrollToBottomButton,
  handleScrollToBottomClick,
  handleSubmit,
  chatbotPlaceholder,
  isMobile,
  chatInputRef,
  handleOnChange,
  children,
}: Readonly<PropsWithChildren<IChatbotLayoutWrapper>>): JSX.Element {
  return (
    <ChatbotWrapper id={CHATBOT_LAYOUT_WRAPPER_ID}>
      <ChatbotHeader
        title={chatbotName}
        onClose={handleClose}
        showNewSessionButton={messages?.length > 1}
        disableNewSessionButton={disabled}
        onNewSession={handleNewSession}
      />

      {children}

      <ChatbotInputContainer>
        {showScrollToBottomButton ? (
          <ChatbotScrollToBottomButton onClick={handleScrollToBottomClick} />
        ) : (
          <EmptyComponent />
        )}
        <ChatInput
          onSubmit={handleSubmit}
          placeholder={chatbotPlaceholder}
          isMobile={isMobile}
          ref={chatInputRef}
          readonly={disabled}
          blocked={disabled}
          onChange={handleOnChange}
        />
      </ChatbotInputContainer>
    </ChatbotWrapper>
  );
}

export default memo(ChatbotLayoutWrapper);
